(function() { window.GUID_273eea64_ecf8_44e7_977d_5a2079bd43af = { getGuid: function() { return "273eea64-ecf8-44e7-977d-5a2079bd43af"; } }; })();
Jodit.plugins.add('fontdropdown', function (editor) {
    editor.events.on('afterInit', function () {
        var li = $('.jodit-toolbar-button_paragraph');
        var svg = li.find('.jodit-icon');
        var span = svg.parent();
        svg.remove();

        span.addClass('jodit-icon');
        span.html('Normal');
        span.css('line-height', '14px');
        span.css('font-size', '14px');
        span.css('width', '140px');

        var $fontValues = $(".jodit-font-values").first();

        var menu = null;

        console.log('before menu');

        li.on('click', function () {

            menu = li.find('.jodit-toolbar-editor-collection');
            console.log('button clicked ' + menu.length + ' ' + menu.find('a').length);

            menu.find('a').on('mousedown', function () {
                console.log('menu clicked  ' + $(this).html());

                span.html($(this).find('span').html());
            });
        });

        $('.jodit-wysiwyg').on('click', function () {
            var parent = $(editor.selection.current());
            parent = parent.closest('p, h1, h2, h3, h4');

            if (parent && parent.length > 0) {
                var fontValue = $fontValues.find("." + parent[0].tagName).attr("value");
                span.html(fontValue);
            }
        });
    });
});
//# sourceMappingURL=jodit.fontdropdown.js.map
